// copy from src/pages/dashboard/components/MetricsCardWrap/index.tsx
// with additional overlapClassName prop

import React from 'react';
import { Card } from "tea-component";
import { useIntl, history } from 'umi';
import "@/pages/dashboard/components/MetricsCardWrap/index.scss";
import MetricsCardWrapTitle from './MetricsCardWrapTitle';
import { getTranslatedText } from '@/pages/dashboard/utils/getTranslatedText';
import classnames from 'classnames';
import ACard from '@/pages/dashboard/components/ACard';

export interface IMetricsCardWrap {
  // 类名
  className?: string;
  overlayClassName?: string;
  // 样式
  style?: React.CSSProperties;
  // 中英文标题
  titleEn: React.ReactNode;
  titleCn: React.ReactNode;
  // 中英文副标题
  subtitleEn?: React.ReactNode;
  subtitleCn?: React.ReactNode;
  // 跳转链接
  link?: (() => void) | string;
  // 链接打开方式：'push' 使用 history.push，'window' 使用 window.open
  jumpType?: 'push' | 'window';
  // 标题跳转链接
  titleLink?: (() => void) | string;
  // 标题链接打开方式：'push' 使用 history.push，'window' 使用 window.open
  titlejumpType?: 'push' | 'window';
  // 标题旁图标(SvgIcon引入)
  icon?: string;
  // 标题旁图标（getImg项目图标引入）
  titleIcon?: string;
  // 标题旁图片地址
  imgUrl?: string;
  // 是否开启icon的info提示（与标题hover的提示互斥）
  isIconTips?: boolean;
  // 中英文指标注释
  tipsEn?: React.ReactNode;
  tipsCn?: React.ReactNode;
  definition?: string;
  source?: string;
  updateTime?: string;
  // 子组件
  children?: React.ReactNode;
  // 头部组件
  contentHeader?: React.ReactNode | JSX.Element;
  // 尾部组件
  contentFooter?: React.ReactNode | JSX.Element;
  // 卡片顶部
  cardHeader?: React.ReactNode;
  // 操作区
  operation?: React.ReactNode;
}

const MetricsCardWrap: React.FC<IMetricsCardWrap> = (props) => {
  const {
    className,
    overlayClassName,
    style,
    children,
    titleEn,
    titleCn,
    subtitleEn,
    subtitleCn,
    link,
    jumpType = 'push',
    titleLink,
    icon,
    titleIcon,
    imgUrl,
    tipsEn,
    tipsCn,
    definition,
    source,
    updateTime,
    isIconTips,
    contentHeader,
    contentFooter,
    cardHeader,
    operation
  } = props;

  const { locale } = useIntl();

  // 标题/副标题中英文翻译
  const title = getTranslatedText(titleEn, titleCn, locale);
  const subtitle = getTranslatedText(subtitleEn, subtitleCn, locale);
  // 注释 - 优先级：自配注释 > 七彩石配置 > 名字适配
  const tips = getTranslatedText(tipsEn, tipsCn, locale);

  const hasLink = typeof link === 'string' ? link.trim() !== '' : link;
  const hasTitleLink = typeof titleLink === 'string' ? titleLink.trim() !== '' : titleLink;

  // 点击卡片跳转页面
  const jumpToLink = () => {
    // 执行 link 跳转
    if (hasLink) {
      if (typeof link === 'string') {
        if (jumpType === 'window') {
          window.open(link);
        } else {
          history.push(link);
        }
      } else {
        link?.();
      }
    }
    // 执行 titleLink 跳转
    if (hasTitleLink) {
      if (typeof titleLink === 'string') {
        if (jumpType === 'window') {
          window.open(titleLink);
        } else {
          history.push(titleLink);
        }
      } else {
        titleLink?.();
      }
    }
  };

  return (
    <ACard url={hasLink ? link as string : ''}>
      <Card className={classnames('dbd-metrics-card-wrap', className, { 'dbd-metrics-card-wrap__link': hasLink })} style={style} onClick={hasLink ? jumpToLink : undefined}>
        <Card.Header>
          {cardHeader}
        </Card.Header>
        <Card.Body
          title={(
            <MetricsCardWrapTitle
              title={title}
              icon={icon}
              titleIcon={titleIcon}
              className={className}
              overlayClassName={overlayClassName}
              imgUrl={imgUrl}
              tips={tips}
              definition={definition}
              source={source}
              updateTime={updateTime}
              isIconTips={isIconTips}
              isJumpable={!!hasLink || !!hasTitleLink}
              onClick={hasTitleLink ? jumpToLink : undefined}
            />
          )}
          subtitle={(
            subtitle && <div className="dbd-metrics-card-wrap__subtitle">
              {subtitle}
            </div>
          )}
          operation={operation}
        >
          {contentHeader}
          {children}
          {contentFooter}
        </Card.Body>
      </Card>
    </ACard>
  );
};

export default MetricsCardWrap;
